import "./CreditPage.css";
import preventClick from "../../utils/PreventClick";
import { useNavigate } from "react-router-dom";
import TimeoutComponent from "../TimeoutComponent/TimeoutComponent";

import CloseIcon from "@mui/icons-material/Close";


const CreditPage = () => {
	const NAVIGATE = useNavigate();
	const imageUrl = "/Assets/nautree.jpg";

	TimeoutComponent(NAVIGATE);

	preventClick();

	return (
		<div className="credit-container" style={{ backgroundImage: `url(${imageUrl})` }}>
			<button className="credit-close-button" onClick={() => NAVIGATE("/")}><CloseIcon style={{ fontSize: 30 }} /></button>
			<div className="credit-filter">
				<div className="credit-block">
					<h2 className="credit-title">
						La naissance du projet
					</h2>
					<p className="credit-title">
						Ce projet est né de la volonté du Musée Sainte-Croix de Poitiers de transmettre de manière ludique toutes les secrets cachés au sein du tableau « Le siège de Poitiers » peint par François Nautré en 1619. Il raconte le déroulement du siège et est une mine d&apos;information historique, d&apos;où la volonté du musée de mettre ces informations à la porté des visiteurs.
					</p>
				</div>
				<div className="credit-line" />
				<div className="credit-block">
					<h2 className="credit-title">
						L&apos;équipe
					</h2>
					<p>
						Le développement de ce projet a été réalisé par des étudiants de BUT3 (2023-2024) en informatique à université de La Rochelle dans le cadre d&apos;un projet tutoré.
					</p>
					<p>Arno Lemoing, Théo Benet, Jules Moulia, Jorian Gaurin, Benjamin Mourceins-Zecchi</p>
				</div>
				<div className="credit-line" />
				<div className="credit-block">
					<h2 className="credit-title">
						Les partenaires
					</h2>
					<p>
					</p>
					<div className="credit-list-partner">
						<div>
							<img alt="" src="./images/logo/alienor.png"  />
							<p>alienor.org - Conseil des musées</p>
						</div>
						<div>
							<img alt="" src="./images/logo/aria.jpg" />
							<p>Association Aria</p>
						</div>
						<div>
							<img alt="" src="./images/logo/akenlab.svg" />
							<p>Akenlab</p>
						</div>
						<div>
							<img alt="" src="./images/logo/izenah.png" />
							<p>I-zenah</p>
						</div>
						<div>
							<img alt="" src="./images/logo/prefet.png" />
							<p>Prefecture Nouvelle-Aquitaine</p>
						</div>
						<div>
							<img alt="" src="./images/logo/univ.png" />
							<p>Université de La Rochelle</p>
						</div>
					</div>

				</div>
			</div>

		</div>
	);
};

export default CreditPage;
